export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";